import React, { useState, useEffect, useCallback } from 'react'
import { Select, AutoComplete, Spin, message } from 'antd'
import {
  ContactPageData,
  GET_CONTACT_LIST_BY_SUPPLIER_AND_GROUP,
} from '@/api/contact'
import { debounce } from 'lodash'
import { getSupplierId } from '@/tools'

const { Option } = Select

export interface ContactSelectorProps {
  value?: string
  onChange?: (value: string, contact?: ContactPageData) => void
  placeholder?: string
  supplierId?: string
  groupCode?: string
  disabled?: boolean
  allowClear?: boolean
  allowInput?: boolean // 新增：是否允许输入框录入
}

const ContactSelector: React.FC<ContactSelectorProps> = ({
  value,
  onChange,
  placeholder = '请选择联系人',
  supplierId = getSupplierId(),
  groupCode,
  disabled = false,
  allowClear = true,
  allowInput = false, // 默认不允许输入框录入
}) => {
  const [contacts, setContacts] = useState<ContactPageData[]>([])
  const [loading, setLoading] = useState(false)
  const [searchValue, setSearchValue] = useState('')

  // 获取联系人列表
  const fetchContacts = useCallback(
    async (name?: string) => {
      if (!supplierId || !groupCode) {
        return
      }

      setLoading(true)
      try {
        const response = await GET_CONTACT_LIST_BY_SUPPLIER_AND_GROUP({
          supplierId,
          groupCode,
          name,
          pageNo: 1,
          pageSize: 50, // 限制返回数量
        })

        if (response.code === 0) {
          setContacts(response.data?.content || [])
        } else {
          message.error(response.msg || '获取联系人列表失败')
        }
      } catch (error) {
        console.error('获取联系人列表失败:', error)
        message.error('获取联系人列表失败')
      } finally {
        setLoading(false)
      }
    },
    [supplierId, groupCode],
  )

  // 防抖搜索
  const debouncedFetchContacts = useCallback(
    debounce((name: string) => {
      fetchContacts(name)
    }, 300),
    [fetchContacts],
  )

  // 初始化加载联系人列表
  useEffect(() => {
    fetchContacts()
  }, [fetchContacts])

  // 处理搜索
  const handleSearch = (searchText: string) => {
    setSearchValue(searchText)
    if (searchText) {
      debouncedFetchContacts(searchText)
    } else {
      fetchContacts()
    }
  }

  // 处理选择
  const handleChange = (selectedValue: string) => {
    if (allowInput) {
      // 允许输入时，直接传递输入的值
      onChange?.(selectedValue, undefined)
    } else {
      // 不允许输入时，查找对应的联系人
      const selectedContact = contacts.find(
        (contact) => contact.id === selectedValue,
      )
      onChange?.(selectedValue, selectedContact)
    }
  }

  // 处理选择（AutoComplete 的 onSelect）
  const handleSelect = (selectedValue: string) => {
    const selectedContact = contacts.find(
      (contact) => contact.id === selectedValue,
    )
    onChange?.(selectedValue, selectedContact)
  }

  // 处理清空
  const handleClear = () => {
    onChange?.('', undefined)
  }

  // 生成 AutoComplete 的选项
  const options = contacts.map((contact) => ({
    value: contact.id,
    label: (
      <div>
        <div>{contact.name}</div>
        {/* <div style={{ fontSize: '12px', color: '#999' }}>
          {contact.duty && `${contact.duty} | `}
          {contact.phone}
        </div> */}
      </div>
    ),
  }))

  return allowInput ? (
    <AutoComplete
      value={value}
      onChange={handleChange}
      onSelect={handleSelect}
      onSearch={handleSearch}
      options={options}
      placeholder={placeholder}
      disabled={disabled}
      allowClear={allowClear}
      filterOption={false}
      notFoundContent={loading ? <Spin size="small" /> : '暂无数据'}
      style={{ width: '100%' }}
      getPopupContainer={() => document.body}
    />
  ) : (
    <Select
      value={value}
      onChange={handleChange}
      onClear={handleClear}
      onSearch={handleSearch}
      placeholder={placeholder}
      disabled={disabled}
      allowClear={allowClear}
      showSearch
      filterOption={false}
      notFoundContent={loading ? <Spin size="small" /> : '暂无数据'}
      style={{ width: '100%' }}
      getPopupContainer={() => document.body}
    >
      {contacts.map((contact) => (
        <Option key={contact.id} value={contact.id}>
          <div>
            <div>{contact.name}</div>
            {/* <div style={{ fontSize: '12px', color: '#999' }}>
              {contact.duty && `${contact.duty} | `}
              {contact.phone}
            </div> */}
          </div>
        </Option>
      ))}
    </Select>
  )
}

export default ContactSelector
import React, { useState, useEffect, useCallback } from 'react'
import { Select, AutoComplete, Spin, message } from 'antd'
import {
  ContactPageData,
  GET_CONTACT_LIST_BY_SUPPLIER_AND_GROUP,
} from '@/api/contact'
import { debounce } from 'lodash'
import { getSupplierId } from '@/tools'

const { Option } = Select

export interface ContactSelectorProps {
  value?: string
  onChange?: (value: string, contact?: ContactPageData) => void
  placeholder?: string
  supplierId?: string
  groupCode?: string
  disabled?: boolean
  allowClear?: boolean
  allowInput?: boolean // 新增：是否允许输入框录入
}

const ContactSelector: React.FC<ContactSelectorProps> = ({
  value,
  onChange,
  placeholder = '请选择联系人',
  supplierId = getSupplierId(),
  groupCode,
  disabled = false,
  allowClear = true,
  allowInput = false, // 默认不允许输入框录入
}) => {
  const [contacts, setContacts] = useState<ContactPageData[]>([])
  const [loading, setLoading] = useState(false)
  const [searchValue, setSearchValue] = useState('')

  // 获取联系人列表
  const fetchContacts = useCallback(
    async (name?: string) => {
      if (!supplierId || !groupCode) {
        return
      }

      setLoading(true)
      try {
        const response = await GET_CONTACT_LIST_BY_SUPPLIER_AND_GROUP({
          supplierId,
          groupCode,
          name,
          pageNo: 1,
          pageSize: 50, // 限制返回数量
        })

        if (response.code === 0) {
          setContacts(response.data?.content || [])
        } else {
          message.error(response.msg || '获取联系人列表失败')
        }
      } catch (error) {
        console.error('获取联系人列表失败:', error)
        message.error('获取联系人列表失败')
      } finally {
        setLoading(false)
      }
    },
    [supplierId, groupCode],
  )

  // 防抖搜索
  const debouncedFetchContacts = useCallback(
    debounce((name: string) => {
      fetchContacts(name)
    }, 300),
    [fetchContacts],
  )

  // 初始化加载联系人列表
  useEffect(() => {
    fetchContacts()
  }, [fetchContacts])

  // 处理搜索
  const handleSearch = (searchText: string) => {
    setSearchValue(searchText)
    if (searchText) {
      debouncedFetchContacts(searchText)
    } else {
      fetchContacts()
    }
  }

  // 处理选择
  const handleChange = (selectedValue: string) => {
    if (allowInput) {
      // 允许输入时，直接传递输入的值
      onChange?.(selectedValue, undefined)
    } else {
      // 不允许输入时，查找对应的联系人
      const selectedContact = contacts.find(
        (contact) => contact.id === selectedValue,
      )
      onChange?.(selectedValue, selectedContact)
    }
  }

  // 处理选择（AutoComplete 的 onSelect）
  const handleSelect = (selectedValue: string) => {
    const selectedContact = contacts.find(
      (contact) => contact.id === selectedValue,
    )
    onChange?.(selectedValue, selectedContact)
  }

  // 处理清空
  const handleClear = () => {
    onChange?.('', undefined)
  }

  // 生成 AutoComplete 的选项
  const options = contacts.map((contact) => ({
    value: contact.id,
    label: (
      <div>
        <div>{contact.name}</div>
        {/* <div style={{ fontSize: '12px', color: '#999' }}>
          {contact.duty && `${contact.duty} | `}
          {contact.phone}
        </div> */}
      </div>
    ),
  }))

  return allowInput ? (
    <AutoComplete
      value={value}
      onChange={handleChange}
      onSelect={handleSelect}
      onSearch={handleSearch}
      options={options}
      placeholder={placeholder}
      disabled={disabled}
      allowClear={allowClear}
      filterOption={false}
      notFoundContent={loading ? <Spin size="small" /> : '暂无数据'}
      style={{ width: '100%' }}
      getPopupContainer={() => document.body}
    />
  ) : (
    <Select
      value={value}
      onChange={handleChange}
      onClear={handleClear}
      onSearch={handleSearch}
      placeholder={placeholder}
      disabled={disabled}
      allowClear={allowClear}
      showSearch
      filterOption={false}
      notFoundContent={loading ? <Spin size="small" /> : '暂无数据'}
      style={{ width: '100%' }}
      getPopupContainer={() => document.body}
    >
      {contacts.map((contact) => (
        <Option key={contact.id} value={contact.id}>
          <div>
            <div>{contact.name}</div>
            {/* <div style={{ fontSize: '12px', color: '#999' }}>
              {contact.duty && `${contact.duty} | `}
              {contact.phone}
            </div> */}
          </div>
        </Option>
      ))}
    </Select>
  )
}

export default ContactSelector
